import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import MuiDatagrid from '../../Shared/MuiDatagrid';
import { useTranslation } from 'react-i18next';
import { StockItemDTO } from '../../../ApiOld/ApiServerVov';

interface WarehouseActionsGridProps {
    rows: StockItemDTO[];
}

const WarehouseActionsGrid: React.FC<WarehouseActionsGridProps> = ({ rows }) => {
    const { t } = useTranslation();

    const columns: GridColDef[] = [
        { field: 'code', headerName: t('code'), flex: 1, minWidth: 100, editable: false },
        { field: 'name', headerName: t('Name'), flex: 1, minWidth: 100, editable: false },
        { field: 'totalUnitsCount', headerName: t('warehouses.supply'), flex: 1, editable: false, renderCell: (params) => params.id !== 'footer' && `${new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value) + (params.row.measureUnitAbbr ? ' ' + params.row.measureUnitAbbr : '')}` },
        { field: 'unitsPrice', headerName: t('warehouses.unitPrice'), flex: 1, editable: false, renderCell: (params) => params.id !== 'footer' && `${new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value)} Kč` },
        { field: 'totalPrice', headerName: t('warehouses.totalPrice'), flex: 1, minWidth: 100, editable: false, renderCell: (params) => `${new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.row.totalUnitsCount * params.row.unitsPrice)} Kč` },
        { field: 'unitsWeight', headerName: t('warehouses.weight'), flex: 1, editable: false, renderCell: (params) => params.id !== 'footer' && `${new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value)} Kg` },
        { field: 'totalWeight', headerName: t('warehouses.totalWeight'), flex: 1, minWidth: 100, editable: false, renderCell: (params) => `${new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.row.totalUnitsCount * params.row.unitsWeight)} Kg` },
    ];

    const calculateTotalPriceSum = (products: StockItemDTO[]) => {
        return products?.reduce((sum, product) => sum + ((product.totalUnitsCount ?? 0) * (product.unitsPrice ?? 0)), 0) ?? 0;
    };

    const calculateTotalWeightSum = (products: StockItemDTO[]) => {
        return products?.reduce((sum, product) => sum + ((product.totalUnitsCount ?? 0) * (product.unitsWeight ?? 0)), 0) ?? 0;
    };

    const totalPriceSum = calculateTotalPriceSum(rows);
    const totalWeightSum = calculateTotalWeightSum(rows);

    const footerRow = {
        id: 'footer',
        code: '',
        name: '',
        totalUnitsCount: 1,
        unitsPrice: totalPriceSum,
        unitsWeight: totalWeightSum
    };

    const rowsWithFooter = [...(rows ?? []), footerRow];

    return (
        <MuiDatagrid
            columns={columns}
            rows={rowsWithFooter}
            editMode="row"
        />
    );
};

export default WarehouseActionsGrid;